import { CircularProgress } from "@mui/material";
import React, { ReactNode } from "react";
import useAccessModule from "src/hooks/useAccessModule";
import useLocalStorageData from "src/hooks/useLocalStorageData";
import { useNavigate } from "react-router-dom";
import { navigation } from "src/navigation";
import { ModulesTypes } from "src/redux/slices/access/userAcessSlice";
import store from "src/redux/store";
import LoginFormWrapper from "src/screens/Login/LoginFormWrapper";
import AccessDenied from "src/utils/AccessDenied";
import { UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";

type Props = {
  moduleName: string;
  actionName?: string;
  component: ReactNode;
};

const AuthHOC = ({ moduleName, actionName, component }: Props) => {
  const { isModuleAuthorize, userAccessIsloading } = useAccessModule();
  const navigate = useNavigate()
  const { AuthToken } = useLocalStorageData();
  if (userAccessIsloading) {
    // Show loading spinner if user access data is not available yet
    return (
      <div className="flex justify-center  items-center w-screen h-screen bg-white">
        <CircularProgress />
      </div>
    );
  }
  const getRedirectToPermisssionModule = () => {
    const { userAccessItems } = store.getState().userAccess; 
    let pathName = "/welcome"


    for (const nav of navigation) {
      const isExist = userAccessItems?.modules?.find((module: ModulesTypes) => module.moduleName === nav.moduleName);
      if (isExist) {
        pathName = "/welcome"
        switch (nav.moduleName) {
          case UserModuleNameTypes.CONFIGURATION:
            return navigate(pathName)
          case UserModuleNameTypes.FINANCE:
            return navigate(pathName)
          case UserModuleNameTypes.MARKETING:
            return navigate(pathName)
          default: {
            return <><AccessDenied /></>

          }
        }

      }
    }
    if (pathName) {

      navigate(pathName)
    } else {
      return <><AccessDenied /></>
    }

  }
  const ComponentWrapper = () => {
    const isPermission = isModuleAuthorize(moduleName);
    const isActionPermission = isCheckActionsPermission({ moduleName, actionName: actionName as string })
    if (actionName) {
      return <> {isActionPermission ? component : getRedirectToPermisssionModule()} </>;
    } else {
      return <>{isPermission ? component : getRedirectToPermisssionModule()}</>;
    }
  };

  return <>{AuthToken ? <ComponentWrapper /> : <LoginFormWrapper />}</>;
};

export default AuthHOC;
